import AssetsDocumentsPage from "domains/liquidity/pages/AssetsDocumentsPage/AssetsDocumentsPage";

export default AssetsDocumentsPage;
